/**
 * Ruta `/asistencia` (006 · T032 · US2): pestaña Asistencia.
 *
 * Misma puerta que Inicio (`useAccessGate`, `features/shell/use-access-gate.ts`) pero con
 * `allowSuspended: true` (contracts/staff-ui.md §1): con la empresa `SUSPENDED` el historial se
 * sigue mostrando de solo lectura (R-12; `realms/staff.ts` ya exime `GET /attendance/marks` desde
 * T006). El resto del comportamiento —activación a medias, sin clave, sesión vencida, aviso de
 * privacidad pendiente— es idéntico al de Inicio.
 */
import { createFileRoute } from '@tanstack/react-router';

import { PrivacyUpdateScreen } from '../features/access/privacy-update';
import { HistoryLoading, HistoryScreen } from '../features/history/history-screen';
import { GateFallback } from '../features/shell/gate-fallback';
import { useAccessGate } from '../features/shell/use-access-gate';
import { t } from '../i18n';

export function AsistenciaGate() {
  const gate = useAccessGate({ allowSuspended: true });

  if (gate.status === 'LOADING') {
    return <HistoryLoading />;
  }
  if (gate.status === 'OFFLINE' || gate.status === 'ERROR') {
    return <GateFallback status={gate.status} retry={gate.retry} active="history" title={t('history.title')} lead={t('history.subtitle')} />;
  }
  if (gate.status === 'PRIVACY_PENDING') {
    return <PrivacyUpdateScreen version={gate.me.privacy_notice.version} />;
  }
  return <HistoryScreen />;
}

export const Route = createFileRoute('/asistencia')({
  component: AsistenciaGate,
});
